<template>
  <footer>
    <div class="footer-content">
      <div class="footer-logo">
        <img src="./../assets/imgs/logo.png" />
      </div>
      <div class="footer-info">
        <p style="margin-top: 0px;">
          <router-link to="/copyright/yyzz"
                       target="_blank">营业执照</router-link>
          <!-- <a href="./../assets/imgs/images/yyzz.jpg" target="_blank"></a>  -->
          |
          <router-link to="/copyright/cbfw"
                       target="_blank">网络出版服务许可证</router-link>
          <!-- <a href="./cbfw.html" target="_blank">网络出版服务许可证</a>  -->
          |
          <router-link to="/copyright/yyyc"
                       target="_blank">营业性演出许可证</router-link>
          <!-- <a href="./yyyc.html" target="_blank">营业性演出许可证</a> -->
        </p>
        <p>
          <router-link to="/copyright/jicp"
                       target="_blank">ICP证070364号</router-link>
          <!-- <a href="./jicp.html" target="_blank">ICP证070364号</a> |  -->
          <a href="http://beian.miit.gov.cn"
             target="_blank">京ICP备08011423号</a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020226"
             target="_blank">京公网安备
            11010802020226号</a>
          <!-- <a href="./../assets/imgs/images/wlwh.jpg" target="_blank">京网文【2017】10770-1255号</a> -->
        </p>
        <p>信息网络传播视听许可证号：
          <router-link to="/copyright/wlcbst"
                       target="_blank">0108298</router-link>
          <!-- <a href="./wlcbst.html" target="_blank">0108298</a>  -->
          | 互联网药品信息服务资格证书
          <router-link to="/copyright/ypxx"
                       target="_blank">（京）-非经营性-2018-0219</router-link>
          <!-- <a href="./../assets/imgs/images/ypxx.jpg" target="_blank">（京）-非经营性-2018-0219</a>  -->
          | 广播电视节目制作经营许可证：
          <router-link to="/copyright/dsjm"
                       target="_blank">(京)字第01166号</router-link>
          <!-- <a href="./../assets/imgs/images/dsjm.jpg" target="_blank">(京)字第01166号</a> -->
        </p>
        <p>
          <a href="http://www.12377.cn"
             target="_blank">中国互联网举报中心</a> |
          <a href="http://www.12377.cn/node_548446.htm"
             target="_blank">网络举报app下载</a> |
          <a href="http://report.12377.cn:13225/toreportinputNormal_anis.do"
             target="_blank">网上有害信息举报专区</a> |
          <a href="http://www.12377.cn/"
             target="_blank">网上暴恐有害信息举报</a> | 违法和不良信息举报电话：010-62036993
        </p>
        <p>举报邮箱：baofeng@baofeng.com Copyright © 2019 暴风影音 All Rights Reserved</p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {

}
</script>
<style lang="less" scoped>
footer {
  width: 100%;
  background: #16161c;
  .footer-content {
    width: 1100px;
    margin: 0 auto;
    color: #fff;
    padding: 50px 0;
    div {
      display: inline-block;
    }
    a,
    p {
      font-size: 12px;
      line-height: 24px;
    }
    .footer-info {
      border-left: 1px solid #d8d8d8;
      padding-left: 60px;
    }
    .footer-logo {
      width: 150px;
      height: 40px;
      vertical-align: top;
      margin-top: 40px;
      margin-right: 60px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonFooter.vue